export function structuralClone(value: any) {
    return JSON.parse(JSON.stringify(value));
}
